import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ResourceNotFoundComponent } from '../../layout/errors/resource-not-found/resource-not-found.component';
import { CaseInsensitiveMatcher } from '../../shared/services/url-matcher/caseinsensitiveurlmatcher';
import { InstituationComponent } from './list/instituation.component';

const routes: Routes = [
  { path: '', redirectTo: 'notfound', pathMatch: 'full' },
  { path: 'notfound', component: ResourceNotFoundComponent },
  { matcher: CaseInsensitiveMatcher('list'), component: InstituationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InstituationRoutingModule {}
